import styles from "./index.module.css";

const PrivacyPolicy = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.mainTitle}>MACHINAT Privacy Policy</h1>

        <section className={styles.section}>
          <h2>1. Introduction</h2>
          <p>
            MACHINAT respects your privacy and is committed to protecting Data. This Privacy Policy will inform you as
            to how we look after Data when you visit and use our Mobile Application and/or Website (regardless of where
            you visit it from) and tell you about your privacy rights and how the law protects you.
          </p>
        </section>

        <section className={styles.section}>
          <h2>2. Glossary</h2>
          <dl className={styles.definitionList}>
            <dt>You OR Your:</dt>
            <dd>shall refer to the users of our App.</dd>
            <dt>Data:</dt>
            <dd>the information that we collect from you while using the App.</dd>
            <dt>Service:</dt>
            <dd>means the services provided through MACHINAT App.</dd>
          </dl>
        </section>

        <section className={styles.section}>
          <h2>3. Important Information and Who We Are</h2>

          <div className={styles.subsection}>
            <h3>3.1 Purpose of this Privacy Policy</h3>
            <p>
              This Privacy Policy aims to give you information on how MACHINAT collects and processes Data through your
              use of our App, including any Data you may provide through this App when you register and/or use our
              Services, as well as install and sign up to our App.
            </p>
            <p>We do not knowingly collect Data relating to children.</p>
            <p>
              It is important that you read this Privacy Policy along with our Terms and Conditions when we are
              collecting or processing Data about you so that you are fully aware of how and why we are using this Data.
              This Privacy Policy supplements other notices and Privacy Policies and is not intended to override them.
            </p>
          </div>

          <div className={styles.subsection}>
            <h3>3.2 Controller</h3>
            <p>
              MACHINAT is the controller and responsible for Data (referred to as &quot;MACHINAT&quot;, &quot;we&quot;,
              &quot;us&quot; or &quot;our&quot; in this Privacy Policy). MACHINAT is the controller and responsible for
              this App.
            </p>
          </div>

          <div className={styles.subsection}>
            <h3>3.3 Contact details</h3>
            <p>
              If you have any questions about this Privacy Policy or our privacy practices, please contact us through
              the email address:
            </p>
            <p className={styles.email}>contact@MACHINAT.com</p>
          </div>

          <div className={styles.subsection}>
            <h3>3.4 Changes to the Privacy Policy and your duty to inform us of changes</h3>
            <p>
              We keep our Privacy Policy under regular review. It is important that the Data we hold about you is
              accurate and current. Please keep us informed if Data changes during your relationship with us.
            </p>
          </div>

          <div className={styles.subsection}>
            <h3>3.5 Third-party Links</h3>
            <p>
              This Platform (App or Website) may include links to third-party websites, plug-ins and applications.
              Clicking on those links or enabling those connections may allow third parties to collect or share Data
              about you. We do not control these third-party applications/websites and we are not responsible for their
              privacy statements. We recommend for you to read the Privacy Policy of every application/website you
              visit.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2>4. Data that we collect</h2>
          <p>
            Data means any information about an individual from which that person can be identified. It does not include
            Data where the identity has been removed (anonymous Data).
          </p>
          <p>
            We may collect, use, store and transfer different kinds of Data about you which is including, but not
            limited to the following:
          </p>
          <ul className={styles.dataList}>
            <li>
              Identity Data included but not limited to name, ID/Passport, username or similar identifier, date of birth
              and gender.
            </li>
            <li>Contact Data includes e-mail address and mobile number.</li>
            <li>Financial Data includes bank account and payment card details.</li>
            <li>
              Technical Data includes your login data, browser type and version, time zone setting and location, browser
              plug-in types and versions, operating system and platform, and other technology on the devices you use to
              access the App/Website.
            </li>
            <li>
              Profile Data includes your username and password, your interests, preferences, purchasing power, reviews
              and ratings, feedback and survey responses.
            </li>
            <li>Usage Data includes information about how you use our App.</li>
          </ul>
          <p>
            We also collect, use and share aggregated Data such as statistical or demographic Data for any purpose.
            Aggregated Data could be derived from Data but is not considered Data in law as this Data will not directly
            or indirectly reveal your identity.
          </p>
        </section>

        <section className={styles.section}>
          <h2>5. If you fail to provide Data</h2>
          <p>
            Where we need to collect Data by law, by using our App, and you fail to provide the required Data, we may
            not be able to perform our Services. We will notify you if this is the case at the time.
          </p>
        </section>

        <section className={styles.section}>
          <h2>6. How is Data collected?</h2>
          <div className={styles.subsection}>
            <h3>6.1 Direct interactions</h3>
            <p>
              You may give us your Identity, contact and financial Data by filling in forms or by corresponding with us
              by phone or e-mail or otherwise. This includes Data you provide when you:
            </p>
            <ul className={styles.dataList}>
              <li>Create an account on, or exploit, our App;</li>
              <li>Enter a social competition, promotion or survey; or</li>
              <li>Provide us with feedback or contact us.</li>
            </ul>
          </div>

          <div className={styles.subsection}>
            <h3>6.2 Automated technologies or interactions</h3>
            <p>
              As you interact with our App/Website, we will automatically collect technical data about your browsing
              actions and patterns. We collect this Data by using cookies, server logs and other similar technologies.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2>7. How we use Data</h2>
          <p>
            We will only use Data when the law allows us to. Most commonly, we will use Data in the following
            circumstances:
          </p>
          <ul className={styles.dataList}>
            <li>
              Where it is necessary for our legitimate interests (or those of a third party) and your interests and
              fundamental rights do not override those interests.
            </li>
            <li>Where we need to comply with a legal obligation.</li>
            <li>Where we need to set up your account and administrate it.</li>
            <li>Where we need to carry out surveys.</li>
            <li>Where we need to personalize content, user experience or business information.</li>
            <li>Where you have given consent.</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>8. Purposes for which we will use Data</h2>
          <div className={styles.subsection}>
            <h3>A) Performance of our Services:</h3>
            <p>We process Data because it is necessary for the performance of our Services through our App.</p>
            <p>In this respect, we use Data for the following:</p>
            <ul className={styles.dataList}>
              <li>To prepare a proposal for you regarding the Services we offer;</li>
              <li>To provide you with the Services as set in the scope of our Services;</li>
              <li>To deal with any complaints or feedback you may have;</li>
              <li>For any other purpose for which you provide us with the Data which we collect.</li>
            </ul>
          </div>

          {/* Additional sections B through J */}
        </section>

        <section className={styles.section}>
          <h2>9. Disclosures of Data</h2>
          <p>
            We may share Data with third parties to whom we may choose to sell, transfer or merge parts of our business
            or our assets. Alternatively, we may seek to acquire other businesses or merge with them. If a change
            happens to our business, then the new owners may use Data in the same way as set out in this Privacy Policy.
          </p>
        </section>

        <section className={styles.section}>
          <h2>10. Data security</h2>
          <p>
            We have put in place appropriate security measures to prevent Data from being accidentally lost, used or
            accessed in an unauthorized way, altered or disclosed. In addition, we limit access to Data to those
            employees, contractors, third party service providers and other parties who have a valid need to know.
          </p>
        </section>

        <section className={styles.section}>
          <h2>11. Data retention</h2>
          <p>
            We will only retain Data for as long as reasonably necessary to fulfil the purposes we collected it for,
            including for the purposes of satisfying any legal, regulatory or reporting requirements.
          </p>
        </section>

        <section className={styles.section}>
          <h2>12. What we may need from you</h2>
          <p>
            We may need to request specific information from you to help us confirm your identity and ensure your right
            to access Data (or to exercise any of your other rights).
          </p>
        </section>

        <section className={styles.section}>
          <h2>Your Legal Rights</h2>
          <p>You have the right to:</p>
          <ul className={styles.rightsList}>
            <li>Access to Data on our App</li>
            <li>Request correction of the Data</li>
            <li>Request erasure of personal Data</li>
            <li>Object to processing of Data</li>
            <li>Request the transfer of the Data</li>
            <li>Withdraw consent at any time</li>
          </ul>
        </section>

        <footer className={styles.footer}>
          <p>
            If you have any questions about how we use Data, or you wish to exercise any of the rights set out above,
            please contact us on our contact details mentioned in Section 3.3 of this Privacy Policy.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
